import axios from '/src/common/axios'

export default {
  save: function (data) {
    return axios.post('/api/vacancy/saveApplicant', data)
  },  
  stopSearch: function () {
    return axios.post('/api/vacancy/stopSearchWork', {})
  },  
  startSearch: function () {
    return axios.post('/api/vacancy/startSearchWork', {})
  },
  getIsSearch: function () {
    return axios.get('/api/vacancy/isSearch')
  },
  find: function () {
    return axios.get('/api/vacancy/getApplicant')
  },
}